import React from "react";
import l from "components/util/l";
import PermissionGridField from "components/util/helpers/user/permissions/PermissionField";
import { PERMISSIONS } from "components/util/permissions";

const ProcessPermissionField = ({
  flowId,
  onlyAdminRoles,
  values,
  setFieldValue,
  setValues
}) =>
  <PermissionGridField
    flowId={flowId}
    onlyAdminRoles={onlyAdminRoles}
    fields={[
      {
        name: PERMISSIONS.NODE_EXECUTE,
        label: l("Ejecutar proceso%SA219"),
      },
    ]}
    values={values}
    setFieldValue={setFieldValue}
    setValues={setValues}
  />

export default ProcessPermissionField;